import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'errorPage.500.title' }),
    description: translate({ id: 'errorPage.500.description' }),
    primaryAction: translate({ id: 'errorPage.500.primaryAction' }),
    secondaryAction: translate({ id: 'errorPage.500.secondaryAction' }),
  }))

  return api
}
